import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import Button from '../../../../components/Button';
import CardCustomization from '../../../../components/CardCustomization/CardCustomization';
import AppConfig from '../../../../config';
import { updateCardCreationDetails } from '../../../../store/slices/card/card';
import './ChooseCardColor.scss';
import { useState } from 'react';

const { routes } = AppConfig;

const MockCardData = {
	label: 'Test label',
	color: 'purple',
	Name: 'Volodymyr Koz',
	number: '5457325733771221',
};

const ChooseCardColor = () => {
	const dispatch = useDispatch();
	const navigate = useNavigate();

	const [color, setColor] = useState(MockCardData.color);
	const [label, setLabel] = useState(MockCardData.label);

	const handleClick = () => {
		dispatch(
			updateCardCreationDetails({
				color,
				label,
			})
		);

		navigate(routes.insertPersonalData);
	};

	return (
		<div className='ChooseCardColor'>
			<div className='ChooseCardColor-main'>
				<CardCustomization
					selectedColor={color}
					label={label}
					onColorChange={setColor}
					onLabelChange={setLabel}
					cardholderName={MockCardData.Name}
					cardNumber={MockCardData.number}
				/>
				<Button onClick={handleClick}>Continue</Button>
			</div>
		</div>
	);
};

export default ChooseCardColor;
